import { useIsMobile } from '@side/pantry';
import { useCore } from '$api-clients/hooks';

const progressReportNames = ['Pricing Plan Progress'];

export function useReports() {
  const isMobile = useIsMobile();

  const { data, isLoading } = useCore('/users/me/reports', undefined, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  // core-service resolved the team this report was granted for; don't re-derive it.
  const reports = (data ?? []).map((report) =>
    progressReportNames.includes(report.name) && report.teamId
      ? {
          ...report,
          mobile: true,
          desktop: true,
          url: `${window.location.origin}/payment/team/${report.teamId}/report/pricing-plan-progress?embedded=true`,
        }
      : report,
  );

  return {
    reports: reports.filter(({ desktop, mobile }) =>
      isMobile ? mobile : desktop,
    ),
    loading: isLoading,
  };
}
